import { useEffect, useState } from 'react';
import { UserApi } from '../../services';

export const VIEW_PROFILE_STATE = {
    VALID: 'valid',
    EXPIRED: 'expired',
    UNDEFINED: 'undefined',
    LOADING: 'loading'
};

const useViewProfileToken = shareToken => {
    const [viewProfileToken, setViewProfileToken] = useState(
        VIEW_PROFILE_STATE.UNDEFINED
    );

    useEffect(() => {
        const verifyToken = token => {
            setViewProfileToken(VIEW_PROFILE_STATE.LOADING);
            UserApi.verifyProfileShareToken({ token })
                .then(response => {
                    if (response?.data?.data?.isActive) {
                        setViewProfileToken(VIEW_PROFILE_STATE.VALID);
                    } else {
                        setViewProfileToken(VIEW_PROFILE_STATE.EXPIRED);
                    }
                })
                .catch(() => {
                    setViewProfileToken(VIEW_PROFILE_STATE.EXPIRED);
                });
        };

        if (shareToken) {
            verifyToken(decodeURIComponent(shareToken));
        }
    }, [shareToken]);

    return viewProfileToken;
};

export default useViewProfileToken;
